import { withFallback } from './helpers/withFallback'

const defaultMqttTesterStore = {
  messages: [],
}

const mqttTesterState = {
  adapter: defaultMqttTesterStore,
}

export function setXappCoreMqttTesterAdapter(adapter) {
  mqttTesterState.adapter = withFallback(adapter, defaultMqttTesterStore)
}

export function useXappCoreMqttTesterAdapter() {
  return mqttTesterState.adapter
}
